var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fe-base-control form-control",class:_vm.stateClass},[_vm._t("default",[_c('span',[_vm._v("Please set field components")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }